import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const AIIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* AI / Brain / Neural network icon */}
      {/* Central node */}
      <circle cx="12" cy="12" r="3" stroke={color} strokeWidth={strokeWidth} fill="none" />
      {/* Outer nodes */}
      <circle cx="12" cy="4" r="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
      <circle cx="19" cy="8" r="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
      <circle cx="19" cy="16" r="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
      <circle cx="12" cy="20" r="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
      <circle cx="5" cy="16" r="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
      <circle cx="5" cy="8" r="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
      {/* Connections */}
      <path
        d="M12 6v3M17.5 9l-3 2M17.5 15l-3-2M12 18v-3M6.5 15l3-2M6.5 9l3 2"
        stroke={color}
        strokeWidth={strokeWidth * 0.75}
        strokeLinecap="round"
      />
    </BaseIcon>
  ),
);

AIIcon.displayName = 'AIIcon';
